import { render, staticRenderFns } from "./NumberRoll.vue?vue&type=template&id=0a156dda&"
import script from "./NumberRoll.vue?vue&type=script&lang=js&"
export * from "./NumberRoll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports